import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
`;

export const Content = styled.ul`
  position: absolute;
  list-style-type: none;
  margin: 0;
  padding: 1.1em 0;
  border-radius: 8px;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.5);
  background: #ffffff;
  color: #4a4a4a;
  z-index: 10;
  overflow: auto;
  max-height: 150px;
  width: ${props => (props.width ? `${props.width}px` : 'auto')};
  ${props => (props.openUp ? 'bottom: 100%;' : 'top: 100%;')}
`;

export const NonInteractiveItem = styled.li`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0.5em 1em 0.5em;
`;

export const Item = styled(NonInteractiveItem)`
  cursor: pointer;

  &:hover {
    background: #ecf2f9;
    cursor: pointer;
  }
`;
